// import { initSentry } from './sentry';
// import { initWebLog } from './weblog';

export function init() {
    if (process.env.NODE_ENV === 'production') {
        // initSentry({
        //     dsn: `${location.protocol}//c9d44a948b0f48e88d1ee6dde56d7d44@sentry.kuaishou.com/172`,
        // });
    }
    // initWebLog();
}
